import React from 'react';
import { Typography } from '@mui/material';
function GeneralCAST() {
  return (
    <Typography
      id="general-feedback-csat"
      className="general-csat"
    ></Typography>
  );
}

export default GeneralCAST;
